/* =========================================================
   PRIMALANE — scroll reveal + ghost parallax
   Upload as assets/primalane-scroll.js
   Safe to include on multiple sections; runs once.
========================================================= */
(function () {
  if (window.__primalaneScrollInit) return;
  window.__primalaneScrollInit = true;

  function init() {
    /* ---- scroll reveal ---- */
    var revealEls = document.querySelectorAll('.pl-reveal');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -60px 0px' }
      );
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---- ghost element parallax ---- */
    var parallaxEls = document.querySelectorAll('.pl-parallax');

    if (parallaxEls.length) {
      var ticking = false;

      var update = function () {
        var vh = window.innerHeight;

        parallaxEls.forEach(function (el) {
          var section = el.closest('section') || el.parentElement;
          var rect = section.getBoundingClientRect();

          /* 0 when section enters viewport bottom, 1 when it exits top */
          var progress = (vh - rect.top) / (vh + rect.height);
          progress = Math.min(Math.max(progress, 0), 1);

          var shift = (progress - 0.5) * 70; /* px range of motion */
          el.style.setProperty('--pl-shift', shift + 'px');
        });

        ticking = false;
      };

      document.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
          }
        },
        { passive: true }
      );

      update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();